import allCategories from 'static/asset_categories.json';
import { t } from 'i18next';
import { isEmpty } from 'lodash';

/**
 * This will check the services the company has and return all asset categories that are available.
 * Additionally, we will need to make sure the 'id' is in the translation files.
 * @param {[]}allowableCategories - the company's allowable categories.
 * @returns {object[]} - a list of options the user is allowed to use
 */
export const getAssetCategories = allowableCategories => {
  if (!allowableCategories) {
    return [];
  }
  //there are no duplicates in the new structure, and it is already sorted.
  return allCategories.reduce((acc, assetCategory) => {
    if (allowableCategories.includes(assetCategory.id)) {
      acc.push({
        id: assetCategory.id,
        name: t(assetCategory.id),
        icon: assetCategory.icon,
      });
    }
    return acc;
  }, []);
};

export const getAssetCategoryData = cat => {
  const data = getAssetCategories([cat]);
  if (isEmpty(data)) return '-';
  return data[0];
};
